<i18n src="./resources/locales.json"></i18n>

<template>
  <EcsSideBarWrapper class="chat-side-bar" :search-placeholder="$t('placeholder')" @search-input-changed="handleSearch">
    <v-row no-gutters>
      <!-- Pending interactions -->
      <EcsSideBarInteractionList
        v-if="displayPendingInteraction"
        id="ecs-pending-interactions-list"
        :header="$t('header.pendingInteractions')"
        :interactions="getPendingInteractions"
        :max-height="pendingInteractionsContainerHeight"
        is-pending
        show-counter
        hide-load-more
      />

      <!-- Active Chat Sessions -->
      <EcsSideBarInteractionList
        v-show="filteredItems.activeInteractions.length"
        :header="$t('header.activeChats')"
        :interactions="filteredItems.activeInteractions"
        :max-height="activeInteractionsContainerHeight"
        show-counter
        hide-load-more
      />

      <!-- Chat History Section -->
      <EcsSideBarInteractionList
        v-show="filteredItems.historicInteractions.length"
        :header="$t('header.historicalChats')"
        :interactions="filteredItems.historicInteractions"
        :max-height="historicInteractionsContainerHeight"
      />

      <!-- Empty History Section -->
      <EcsSideBarTileContent v-if="showTileContent" :header="$t('header.historicalChats')">
        <div class="empty-interaction-history-section pa-2 mx-4">
          <div v-once>
            {{ $t('body.nothing_here') }}
          </div>
          <div v-once>
            {{ $t('body.make_history') }}
          </div>
        </div>
      </EcsSideBarTileContent>

      <SideBarLoadMoreBtn v-if="showTileContent" />
    </v-row>
  </EcsSideBarWrapper>
</template>

<script>
import { mapGetters } from 'vuex';
import EcsSideBarInteractionMixins from '@/mixins/ecs-side-bar-interaction-mixins/EcsSideBarInteractionMixins';
import SideBarLoadMoreBtn from '@/components/ecs-app-side-bar/ecs-side-bar-interaction-item/side-bar-load-more-btn/SideBarLoadMoreBtn';

export default {
  name: 'EcsChatSideBar',

  components: { SideBarLoadMoreBtn },

  mixins: [EcsSideBarInteractionMixins],

  computed: {
    ...mapGetters('INTERACTIONS', ['getActiveChatInteractions', 'getHistoricalChatInteractions']),

    filteredItems() {
      const activeInteractions = this.filterItems(this.getActiveChatInteractions);
      const historicInteractions = this.filterItems(this.getHistoricalChatInteractions);

      return {
        activeInteractions,
        historicInteractions
      };
    },

    showTileContent() {
      return !this.filteredItems.historicInteractions.length;
    }
  },

  methods: {
    getAdditionalSerchableAttributes(item) {
      return '';
    }
  }
};
</script>

<style lang="scss">
.load-more {
  padding: 20px;
  font-size: 12px;
  text-align: center;

  .span {
    color: var(--v-primary-base);
  }

  .v-btn {
    border-radius: 6px !important;
    height: 24px !important;
    line-height: 24px;
  }
}
</style>
